import { Link } from "react-router-dom";
import { getAppUrl } from "@/utils/domain";

export const HeroSection = () => {
  return (
    <section
      className="relative flex flex-col items-center justify-start md:justify-center overflow-hidden"
      style={{ minHeight: "calc(100vh - 3.5rem)" }}
      aria-label="Hero"
    >
      {/* Cover photo */}
      <img
        src="/assets/coverimagewebsite.webp"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover md:object-center"
        style={{ objectPosition: "85% center" }}
      />

      {/* Dark overlay for text legibility */}
      <div
        className="absolute inset-0"
        aria-hidden="true"
        style={{ background: "rgba(10,9,6,0.48)" }}
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-5 py-20 md:py-28 max-w-2xl mx-auto">
        {/* Heading */}
        <h1
          className="font-serif font-normal leading-snug mb-5 md:mb-6"
          style={{
            fontSize: "clamp(2.75rem, 8vw, 5.5rem)",
            color: "#FFFEF5",
            letterSpacing: "-0.02em",
            lineHeight: "1.05",
          }}
        >
          A Life Remembered
        </h1>

        {/* Subtext — matches image */}
        <p
          className="font-sans leading-relaxed mb-10 md:mb-12 max-w-lg"
          style={{
            fontSize: "clamp(0.9rem, 2vw, 1.05rem)",
            color: "rgba(255,254,245,0.72)",
          }}
        >
          A digital memorial on their headstone. Stories, photos, and tributes
          from those who loved them. We handle the care so you can focus on
          remembering.
        </p>

        {/* CTAs — side by side as in image */}
        <div className="flex flex-row items-center gap-4 flex-wrap justify-center">
          {/* Login — pill with subtle border/fill */}
          <a
            href={getAppUrl("/auth")}
            className="inline-flex items-center justify-center px-6 py-2 rounded-full text-sm font-medium transition-colors"
            style={{
              backgroundColor: "rgba(255,254,245,0.92)",
              color: "#1E1F18",
              border: "none",
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.backgroundColor =
                "#FFFFFF";
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.backgroundColor =
                "rgba(255,254,245,0.92)";
            }}
          >
            Login
          </a>

          {/* Find Memorial — text/ghost link */}
          <Link
            to="/search"
            className="inline-flex items-center justify-center text-sm font-medium transition-colors"
            style={{ color: "rgba(255,254,245,0.85)" }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.color = "#FFFFFF";
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLAnchorElement).style.color =
                "rgba(255,254,245,0.85)";
            }}
          >
            Find Memorial
          </Link>
        </div>
      </div>

      {/* Bottom fade transitioning to the next section */}
      <div
        className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none"
        aria-hidden="true"
        style={{
          background:
            "linear-gradient(to bottom, transparent 0%, rgba(255,254,245,0.95) 100%)",
        }}
      />
    </section>
  );
};
